"use strict";

var ButtonGroup = require("app/shared/components/ButtonGroup/button-group");
var Button = require("app/shared/components/Button/button");
var Icon = require("app/shared/components/Icon/icon");

var cx = require("classnames");

var ActivityStatusFilter = React.createClass({
  getInitialState: function() {
    return {
      pending: (this.props.filters.pending === false ? false : true)
    };
  },
  componentDidMount: function() {
    this.updateFilters(true);
  },
  componentDidUpdate: function() {
    this.updateFilters();
  },
  updateFilters: function(wait) {
    this.props.setFilter("pending", this.state.pending, wait);
    this.props.setFilter("offset", 0, wait);
  },
  setPending: function(e) {
    e.preventDefault();
    this.setState({
      pending: true
    });
  },
  removePending: function(e) {
    e.preventDefault();
    this.setState({
      pending: false
    });
  },
  render: function() {
    return (
      <ButtonGroup>
        <Button type="filter" className={this.state.pending ? "selected" : ""} onClick={this.setPending}>
          <span>Pendentes</span>
        </Button>
        <Button type="filter" className={!this.state.pending ? "selected" : ""} onClick={this.removePending}>
          <span>Finalizadas</span>
        </Button>
      </ButtonGroup>
    );
  }
});

module.exports = ActivityStatusFilter;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/ActivityList/activity-status-filter.jsx